export const SENTRY_APPLICATION_KEY = 'netvalve-sentry-filter-qaef453fet45';
